import {cx} from "@emotion/css";
import {ReactComponent as SvgMessageSquare} from "assets/svg/message-square.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmMessageSquareIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgMessageSquare id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
